<script setup lang="ts">
import { RouterLink } from "vue-router";

import BaseButton from "./BaseButton.vue";
import BrandLogo from "./BrandLogo.vue";
</script>

<template>
  <header class="border-b border-app-border bg-app-shell/60 backdrop-blur-md">
    <div class="mx-auto flex max-w-6xl items-center justify-center gap-6 px-6 py-4 md:justify-between">
      <RouterLink class="flex items-center transition-opacity hover:opacity-80" :to="{ name: 'home' }">
        <BrandLogo class="h-24 w-auto shrink-0 md:h-32" />
      </RouterLink>

      <div class="hidden items-center gap-3 md:flex">
        <BaseButton :to="{ name: 'services-categories' }">
          Termin buchen
        </BaseButton>
        <BaseButton :to="{ name: 'products-categories' }" variant="secondary">
          Shop & Abholung
        </BaseButton>
      </div>
    </div>
  </header>
</template>
